export const DELIVERY_FORM_FIELDS = {
  ADDRESS_1: 'address1',
  ADDRESS_2: 'address2',
  ADMIN1: 'admin1',
  ADMIN2: 'admin2',
  ADMIN3: 'admin3',
  ZIP_CODE: 'zipCode',
  COUNTRY: 'country',
  DELIVERY_METHOD: 'deliveryMethod',
  SHIPPING_RATE_ID: 'shippingRateId',
  PICKUP_METHOD: 'pickupMethod',
  MANUAL_DELIVERY_COST: 'manualDeliveryCost',
};
